export default "__VITE_ASSET___a1Nquoz__"